import React, {Component} from 'react';
import * as axios from 'axios';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import * as _ from 'lodash-es';
import {MapTo} from '@adobe/aem-react-editable-components';
import parse from 'html-react-parser';
import {EsriForm, BasicInput, EmailInput, SelectList} from '../ReactForms';
import {toCartModel, cartDataSource, isPersonalOrStudentUse} from '../../utils/ecommerce/cart.js';
import CustomerNumberItemButton from './components/CustomerNumberItemButton.js';
import {getRootDomain} from '../../utils/common/url';
import DataService from './../Cart/DataService.js';
import {Analytics} from '../../utils/common/analytics';
import DOMPurify from 'dompurify';
import CalciteScrim from '../shared/CalciteScrim.js';
import CalciteLoader from '../shared/CalciteLoader.js';
import CustomerNumberCard from './components/CustomerNumberCard.js';
import CalciteButton from '../shared/CalciteButton.js';
import CalciteLink from '../shared/CalciteLink.js';
import CalciteAlert from '../shared/CalciteAlert.js';
import CalciteInputMessage from '../shared/CalciteInputMessage.js';
import BrandHeading from '../shared/BrandHeading.js';
import PropTypes from 'prop-types';
import GeoblockingModal from './components/GeoblockingModal.js';

class CustomerNumber extends Component {
  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(window.location.search);
    this.urls = {};
    this.geoBlockingResponse = {};
    this.analytics = Analytics.getInstance();
    this.analytics.addPageInfo({
      pageType: 'customer-number',
      ecommerce: {
        storeType: Analytics.storeType.OMNI,
        storeFront: Analytics.toStoreFront(this.getCookie('selectedZone')),
      },
    });
    this.checkoutCountryCode = null;

    this.state = {
      isLoaded: false,
      isPristineSelection: true,
      showInvalidError: false,
      isCreatingNewCustomer: false,
      getCustomerError: false,
      createCustomerError: false,
      customerNumbers: [],
      cart: null,
      initCreateCustomer: false,
      selectedCustomerType: null,
      token: this.getJSONCookie('esri_auth') ? this.getJSONCookie('esri_auth').token : null,
      esriAuthInfo: this.getJSONCookie('esri_auth') ? this.getJSONCookie('esri_auth') : null,
      cartId: this.getCookie('eCommCartId'),
      formError: {},
      switchingCustomerNumber: false,
      showGeoBlockingPopup: false,
      onVerifyAddressError: false,
      onVerifyAddressSystemError: false,
      storeDomain: location.hostname.includes('local') ? 'https://aem-dev.esri.com' : location.hostname,
      redirectUri: urlParams && urlParams.has('redirect_uri') ? urlParams.get('redirect_uri') : null,
      userLocale:
        document.documentElement.lang && document.documentElement.lang.includes('-')
          ? document.documentElement.lang
          : 'en-us',
    };

    this.onSelectSwitchCustomerNumber = this.onSelectSwitchCustomerNumber.bind(this);
    this.onSwitchCustomerNumber = this.onSwitchCustomerNumber.bind(this);
    this.initCreateCustomer = this.initCreateCustomer.bind(this);
    this.createNewCustomerNumber = this.createNewCustomerNumber.bind(this);
    this.onCountryChange = this.onCountryChange.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
    this.goToCart = this.goToCart.bind(this);
    this.showHideModal = this.showHideModal.bind(this);
    this.goBackToCustomerNumberList = this.goBackToCustomerNumberList.bind(this);
    this.handleGeoBlockingCtaClick = this.handleGeoBlockingCtaClick.bind(this);
    this.setupProfile = this.setupProfile.bind(this);
    this.onSelectedCustomerNumber = this.onSelectedCustomerNumber.bind(this);

    this.localizedKeys = {
      globalCustomerNumberLabel: this.props.globalCustomerNumberLabel,
      createCustomerNumberLabel: this.props.createCustomerNumberLabel,
      switchCustomerNumberLabel: this.props.switchCustomerNumberLabel,
      cancelLabel: this.props.cancelLabel,
      purchasingForLabel: this.props.purchasingForLabel,
      continueToCheckoutLabel: this.props.continueToCheckoutLabel,
      returnToCartLabel: this.props.returnToCartLabel,
      loadingCustomerNumberLabel: this.props.loadingCustomerNumberLabel,
      selectCustomerNumberLabel: this.props.selectCustomerNumberLabel,
      selectCustomerNumberDescription: this.props.selectCustomerNumberDescription,
      selectCustomerNumberFootnote: this.props.selectCustomerNumberFootnote,
      continueLabel: this.props.continueLabel,
      okayLabel: this.props.okayLabel,
      firstNameLabel: this.props.firstNameLabel,
      lastNameLabel: this.props.lastNameLabel,
      orgNameLabel: this.props.orgNameLabel,
      departmentLabel: this.props.departmentLabel,
      addressLine1Label: this.props.addressLine1Label,
      addressLine2Label: this.props.addressLine2Label,
      cityLabel: this.props.cityLabel,
      stateLabel: this.props.stateLabel,
      countryLabel: this.props.countryLabel,
      postalCodeLabel: this.props.postalCodeLabel,
      emailLabel: this.props.emailLabel,
      phoneNumberLabel: this.props.phoneNumberLabel,
      firstNameRequiredMsg: this.props.firstNameRequiredMsg,
      lastNameRequiredMsg: this.props.lastNameRequiredMsg,
      orgNameRequiredMsg: this.props.orgNameRequiredMsg,
      addressLine1RequiredMsg: this.props.addressLine1RequiredMsg,
      cityRequiredMsg: this.props.cityRequiredMsg,
      stateRequiredMsg: this.props.stateRequiredMsg,
      countryRequiredMsg: this.props.countryRequiredMsg,
      postalCodeRequiredMsg: this.props.postalCodeRequiredMsg,
      emailRequiredMsg: this.props.emailRequiredMsg,
      phoneNumberRequiredMsg: this.props.phoneNumberRequiredMsg,
      customerNumberErrorMessageTitle: this.props.customerNumberErrorMessageTitle,
      customerNumberErrorMessage: this.props.customerNumberErrorMessage,
      verifyAddressErrorTitle: this.props.verifyAddressErrorTitle,
      verifyAddressErrorMessage: this.props.verifyAddressErrorMessage,
      verifyAddressSystemError: this.props.verifyAddressSystemError,
      personalCustomerTypeLabel: this.props.personalCustomerTypeLabel,
      orgCustomerTypeLabel: this.props.orgCustomerTypeLabel,
      newCustomerNumberLabel: this.props.newCustomerNumberLabel,
      orgAccountDescription: this.props.orgAccountDescription,
      personalAccountDescription: this.props.personalAccountDescription,
      customerTypeSelectionDescription: this.props.customerTypeSelectionDescription,
      newLabel: this.props.newLabel,
      customerNumberTitle: this.props.customerNumberTitle,
      newCustomerNumberDescription: this.props.newCustomerNumberDescription,
      backLabel: this.props.backLabel,
      alertTitleNoCustomerSelected: this.props.alertTitleNoCustomerSelected,
      alertMessageNoCustomerSelected: this.props.alertMessageNoCustomerSelected,
      validationErrorMessageNoCustomerSelected: this.props.validationErrorMessageNoCustomerSelected,
    };
    this.customerTypes = [
      {
        type: 'individual',
        title: this.props.customerTypeMeLabel,
        text: this.localizedKeys.personalAccountDescription,
        image: 'https://www.esri.com/content/dam/esrisites/en-us/common/icons/meridian-/person-user-48.svg',
      },
      {
        type: 'business',
        title: this.props.customerTypeOrgLabel,
        text: this.localizedKeys.orgAccountDescription,
        image: 'https://www.esri.com/content/dam/esrisites/en-us/common/icons/meridian-/people-group-48.svg',
      },
    ];
  }

  async componentDidMount() {
    try {
      this.setEnvUrls();
      this.setRedirectUri();

      if (!this.state.token) {
        this.authenticateUser();
      } else {
        const customerNumberRequestBody = {
          emailaddress: this.state.esriAuthInfo.firstName, // done intetionally. This gets replaced by the API with real emailaddress for frontend call.
          token: this.state.token,
          username: this.state.esriAuthInfo.userName,
        };

        let [cartResponse, customerNumbers] = await axios.all([
          this.state.cartId ? DataService.getCart(this.urls.istApiUrl, this.state.cartId) : null,
          !this.state.initCreateCustomer
            ? DataService.getCustomerNumbers(this.urls.istApiUrl, customerNumberRequestBody)
            : [],
        ]);

        if (
          cartResponse
          && cartResponse.metadata
          && cartResponse.metadata.customer
          && cartResponse.metadata.customer.customerNumber
        ) {
          if (
            cartResponse.metadata.customer.customerType === 'new'
            || isNaN(cartResponse.metadata.customer.customerNumber)
          ) {
            customerNumbers.push({
              CustomerNumber: cartResponse.metadata.customer.customerNumber,
              OrganizationName: cartResponse.metadata.customer.customerName,
              Department: cartResponse.metadata.customer.departmentName,
              Address1: cartResponse.metadata.shippingAddress.addressLine1,
              Address2: cartResponse.metadata.shippingAddress.addressLine2,
              City: cartResponse.metadata.shippingAddress.city,
              State: cartResponse.metadata.shippingAddress.stateCode,
              Zipcode: cartResponse.metadata.shippingAddress.postalCode,
              Country: cartResponse.metadata.shippingAddress.countryCode,
              IndustryKey: cartResponse.metadata.customer.industryCode,
              TaxJurisdictionCode: cartResponse.metadata.customer.taxAreaId,
              CustomerAssignmentGroup: cartResponse.metadata.customer.customerAssignmentGroup,
              selected: true,
            });
          } else {
            customerNumbers.map(
              (customerNumberItem) =>
                (customerNumberItem.selected
                  = customerNumberItem.CustomerNumber === parseInt(cartResponse.metadata.customer.customerNumber)),
            );
          }
        }

        if (customerNumbers.length <= 0) {
          this.initCreateCustomer(cartResponse);
        } else {
          this.setState({
            isLoaded: true,
            getCustomerError: false,
            cart: cartResponse,
            customerNumbers: customerNumbers,
          });
        }

        this.analytics.addPageInfo({
          ecommerce: {
            ...this.analytics.getPageItem('ecommerce'),
            storeFront: Analytics.toStoreFront(cartResponse?.zone),
            distributorNumber: cartResponse?.distributorNumber,
          },
        });
      }
    } catch (error) {
      this.setState({isLoaded: true, getCustomerError: true});
    }
  }

  render() {
    let renderData;

    if (!this.state.isLoaded) {
      renderData = this.renderLoader();
    } else if (this.state.isLoaded && this.state.getCustomerError) {
      renderData = this.renderGetCustomerError();
    } else if (this.state.customerNumbers.length > 0 && !this.state.initCustomerCreation) {
      renderData = this.renderGetCustomerList();
    } else {
      renderData = this.renderNewCustomer();
    }

    return (
      <div className="customer-number-multi grid-container padding-leader-1" id="customerNumber">
        {(this.state.switchingCustomerNumber || this.state.isCreatingNewCustomer) && (
          <CalciteScrim style={{position: 'fixed'}}>
            <CalciteLoader />
          </CalciteScrim>
        )}
        {this.state.showInvalidError && (
          <CalciteScrim style={{position: 'fixed'}} onClick={() => this.setState({showInvalidError: false})}>
            <CalciteAlert
              icon="exclamation-mark-triangle"
              kind="danger"
              autoCloseDuration="fast"
              open={this.state.showInvalidError}
              onClose={() => this.setState({showInvalidError: false})}
            >
              <div slot="title">{this.localizedKeys.alertTitleNoCustomerSelected}</div>
              <div slot="message">{this.localizedKeys.alertMessageNoCustomerSelected}</div>
            </CalciteAlert>
          </CalciteScrim>
        )}
        <GeoblockingModal
          open={this.state.showGeoBlockingPopup}
          countryCode={this.checkoutCountryCode}
          geoBlockingResponse={this.geoBlockingResponse}
          onCtaClick={this.handleGeoBlockingCtaClick}
        />

        <div className="customer-number-wrapper">
          {this.state.customerNumbers.length > 0 && !this.state.initCustomerCreation && (
            <div className="block">
              <BrandHeading
                title={this.localizedKeys.customerNumberTitle || this.localizedKeys.selectCustomerNumberLabel}
                description={this.localizedKeys.selectCustomerNumberDescription}
                fontSize="2"
              />
            </div>
          )}
          <div className="block margin-bottom--2">
            <CalciteLink
              onClick={
                this.state.initCustomerCreation && this.state.customerNumbers.length > 0
                  ? this.goBackToCustomerNumberList
                  : this.goToCart
              }
              iconStart="arrow-left"
              iconFlipRtl="both"
              appearance="transparent"
            >
              {this.localizedKeys.backLabel || this.localizedKeys.cancelLabel}
            </CalciteLink>
          </div>
          <div className="card block trailer-1">{renderData}</div>
          {this.state.isLoaded && (
            <div className="font-size--3" style={{padding: '10px'}}>
              <div className="richtext-container">
                {this.localizedKeys.selectCustomerNumberFootnote
                && parse(this.localizedKeys.selectCustomerNumberFootnote)}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderLoader() {
    return (
      <CalciteLoader
        text={this.localizedKeys.loadingCustomerNumberLabel}
        label={this.localizedKeys.loadingCustomerNumberLabel}
        type="indeterminate"
      />
    );
  }

  renderGetCustomerError() {
    return (
      <div className="cart-alert topborder padding-leader-1 padding-trailer-1">
        <div className="cart-alert-icon"></div>
        <div className="cart-alert-text">
          <span className="avenir-demi"> {this.localizedKeys.customerNumberErrorMessageTitle} </span>
          <div className="richtext-container">
            {this.localizedKeys.customerNumberErrorMessage && parse(this.localizedKeys.customerNumberErrorMessage)}
          </div>
          <CalciteButton onClick={this.goToCart} scale="l">
            {this.localizedKeys.returnToCartLabel}
          </CalciteButton>
        </div>
      </div>
    );
  }

  renderGetCustomerList() {
    const customerNumbers = this.state.customerNumbers.map((customerNumber, index) => {
      return (
        <div key={index} className="padding-bottom--4">
          <CustomerNumberCard
            customerNumber={customerNumber}
            onSelectedCustomerNumber={this.onSelectedCustomerNumber}
            localizedKeys={this.localizedKeys}
          />
        </div>
      );
    });

    return (
      <>
        <div className="customerNumber-items"> {customerNumbers} </div>
        <div>
          <CalciteButton
            appearance="outline-fill"
            width="full"
            onClick={() => this.initCreateCustomer(this.state.cart)}
            iconStart="plus-circle"
            scale="l"
            kind="neutral"
          >
            {this.localizedKeys.createCustomerNumberLabel}
          </CalciteButton>
          <div className="margin-top--8">
            <CalciteButton
              width="full"
              scale="l"
              onClick={this.onSelectSwitchCustomerNumber}
              iconEnd="arrow-right"
              iconFlipRtl="both"
            >
              <div className="padding-y--3">
                {this.localizedKeys.continueLabel || this.localizedKeys.switchCustomerNumberLabel}
              </div>
            </CalciteButton>
          </div>
          {!this.state.isPristineSelection && !this.state.customerNumbers?.some((c) => c?.selected) && (
            <CalciteInputMessage icon="exclamation-mark-triangle" status="invalid">
              {this.localizedKeys.validationErrorMessageNoCustomerSelected}
            </CalciteInputMessage>
          )}
        </div>
      </>
    );
  }

  renderNewCustomer() {
    const newCustomerInfo = this.state.newCustomerInfo;

    return (
      <div id="newCustomerCreationDiv">
        {/* Customer Creation Error */}
        <div
          id="createCustomerErrorModal"
          className="opacityLayer"
          data-attribute={this.state.customerCreationError ? 'visible' : 'hidden'}
        ></div>
        <div
          id="createCustomerErrorMessage"
          className="mainErrorMessage cart-alert topborder globalError"
          data-attribute={this.state.customerCreationError ? 'visible' : 'hidden'}
        >
          <div className="cart-alert-icon"></div>
          <div className="cart-alert-text">
            <h2 className="avenir-demi"> {this.localizedKeys.customerNumberErrorMessageTitle} </h2>
            <div className="avenir-light padding-trailer-1">
              <div className="richtext-container">
                {this.localizedKeys.customerNumberErrorMessage && parse(this.localizedKeys.customerNumberErrorMessage)}
              </div>
            </div>
            <CalciteButton scale="m" onClick={this.goToCart}>
              <div className="button-slotted-content">
                <span className="button-slotted-content__text">{this.localizedKeys.returnToCartLabel}</span>
                <calcite-icon
                  class="button-slotted-content__icon margin-left--4 flip-rtl"
                  scale="s"
                  icon="arrow-right"
                ></calcite-icon>
              </div>
            </CalciteButton>
          </div>
        </div>

        {/* Verify Address Modal */}
        <div
          id="verifyAddressErrorModal"
          className="opacityLayer"
          data-attribute={this.onVerifyAddressError ? 'visible' : 'hidden'}
        ></div>
        <div
          id="verifyAddressErrorMessage"
          className="mainErrorMessage cart-alert topborder globalError"
          data-attribute={this.onVerifyAddressError ? 'visible' : 'hidden'}
        >
          <div className="cart-alert-icon"></div>
          <div className="cart-alert-text">
            {this.localizedKeys.verifyAddressErrorTitle && (
              <h2 className="avenir-demi"> {this.localizedKeys.verifyAddressErrorTitle} </h2>
            )}
            <div className="richtext-container">
              {this.localizedKeys.verifyAddressSystemError
              && this.localizedKeys.verifyAddressErrorMessage
              && parse(
                this.state.onVerifyAddressSystemError
                  ? this.localizedKeys.verifyAddressSystemError
                  : this.localizedKeys.verifyAddressErrorMessage,
              )}
            </div>
            <CalciteButton
              className="margin-right-2"
              scale="m"
              onClick={() => this.showHideModal('#verifyAddressErrorModal', '#verifyAddressErrorMessage', 'close')}
            >
              <div className="button-slotted-content">
                <div className="button-slotted-content__text">{this.localizedKeys.okayLabel}</div>
                <calcite-icon
                  class="button-slotted-content__icon margin-left--4 flip-rtl"
                  scale="s"
                  icon="arrow-right"
                ></calcite-icon>
              </div>
            </CalciteButton>
          </div>
        </div>
        <BrandHeading
          category={this.localizedKeys.newCustomerNumberLabel}
          title={this.localizedKeys.customerNumberTitle || this.localizedKeys.purchasingForLabel}
          description={this.localizedKeys.newCustomerNumberDescription}
          fontSize="2"
        />
        <div className="customeTypeWrapper">
          <p className="font-size--1">{this.localizedKeys.customerTypeSelectionDescription}</p>
          <div className="customer-number-type__list">
            {this.customerTypes.map((customerType, index) => {
              return (
                <div key={index} className="customer-number-type__option">
                  <CustomerNumberItemButton
                    className="customer-number-type__button"
                    selected={this.state.selectedCustomerType === customerType.type}
                    onClick={this.onSelectedCustomerType.bind(this, customerType)}
                  >
                    <div className="customer-number-type__wrapper">
                      <img
                        className="customer-number-type__icon"
                        src={customerType.image}
                        alt={customerType.title}
                        style={{height: '48px'}}
                      />
                      <p className="customer-number-type__text ui-text-2 font-size--1 avenir-demi">
                        {' '}
                        {customerType.title}
                      </p>
                      <p className="customer-number-type__text ui-text-2 font-size--3"> {customerType.text}</p>
                      {this.state.selectedCustomerType === customerType.type && (
                        <div className="customer-number-type__checkmark">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                            <path
                              fill="#0079c1"
                              d="M8 .15A7.85 7.85 0 1 0 15.85 8 7.85 7.85 0 0 0 8 .15zM6.557 11.592L3.31 8.346l1.163-1.162L6.557 9.27l5.172-5.17 1.162 1.162z"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  </CustomerNumberItemButton>
                </div>
              );
            })}
          </div>
        </div>

        {this.state.selectedCustomerType && (
          <div className="customerForm">
            <EsriForm onSubmit={this.createNewCustomerNumber}>
              <BasicInput
                label={this.localizedKeys.firstNameLabel}
                name="FirstName"
                value={newCustomerInfo.FirstName}
                required={true}
              />
              <BasicInput
                label={this.localizedKeys.lastNameLabel}
                name="LastName"
                value={newCustomerInfo.LastName}
                required={true}
              />
              {this.state.selectedCustomerType === 'business' && (
                <BasicInput
                  label={this.localizedKeys.orgNameLabel}
                  name="OrganizationName"
                  value={newCustomerInfo.OrganizationName ? newCustomerInfo.OrganizationName : ''}
                  required={true}
                />
              )}
              {this.state.selectedCustomerType === 'business' && (
                <BasicInput
                  label={this.localizedKeys.departmentLabel}
                  name="DepartmentName"
                  value={newCustomerInfo.DepartmentName ? newCustomerInfo.DepartmentName : ''}
                />
              )}
              <BasicInput
                label={this.localizedKeys.addressLine1Label}
                name="Street"
                value={newCustomerInfo.Street ? newCustomerInfo.Street : ''}
                required={true}
              />
              <BasicInput
                label={this.localizedKeys.addressLine2Label}
                name="Address2"
                value={newCustomerInfo.Address2 ? newCustomerInfo.Address2 : ''}
              />
              <BasicInput
                label={this.localizedKeys.cityLabel}
                name="City"
                value={newCustomerInfo.City}
                required={true}
              />
              <SelectList
                label={this.localizedKeys.countryLabel}
                name="CountryCode"
                value={newCustomerInfo.CountryCode}
                options={this.state.countries}
                required={true}
                onChange={(event) => this.onCountryChange(event)}
              />
              <SelectList
                label={this.localizedKeys.stateLabel}
                name="StateCode"
                value={newCustomerInfo.StateCode}
                onChange={(event) => this.onStateChange(event)}
                options={this.state.states}
                required={true}
              />

              <BasicInput
                label={this.localizedKeys.postalCodeLabel}
                name="PostalCode"
                value={newCustomerInfo.PostalCode}
                required={true}
              />
              <EmailInput
                label={this.localizedKeys.emailLabel}
                name="PrimaryEmail"
                value={newCustomerInfo.PrimaryEmail}
                required={true}
              />
              <BasicInput
                label={this.localizedKeys.phoneNumberLabel}
                name="Phone"
                value={newCustomerInfo.Phone}
                required={true}
              />
              <div className="padding-leader-1">
                <CalciteButton
                  scale="l"
                  width="full"
                  type="submit"
                  disabled={this.state.isCreatingNewCustomer || undefined}
                  iconEnd="arrow-right"
                  iconFlipRtl="both"
                >
                  {this.localizedKeys.continueLabel || this.localizedKeys.continueToCheckoutLabel}
                </CalciteButton>
              </div>
            </EsriForm>
          </div>
        )}
      </div>
    );
  }

  goBackToCustomerNumberList() {
    this.setState({initCustomerCreation: false, selectedCustomerType: null});
  }

  async createNewCustomerNumber(formData) {
    let verifyAddress;

    try {
      this.setState({
        onVerifyAddressError: false,
        onVerifyAddressSystemError: false,
        isCreatingNewCustomer: true,
      });

      const newCustomerInfo = this.state.newCustomerInfo;
      const localeInfo = await DataService.locale(this.urls.istApiUrl, newCustomerInfo.CountryCode);
      let cart = this.state.cart;

      if (!cart) {
        cart = await this.createCart(localeInfo);
        this.setState({cart: cart});
      }

      // Set the form data value to the newCustomerInfo
      newCustomerInfo.FirstName = formData.FirstName;
      newCustomerInfo.LastName = formData.LastName;
      newCustomerInfo.OrganizationName
        = this.state.selectedCustomerType === 'individual'
          ? newCustomerInfo.FirstName + ' ' + newCustomerInfo.LastName
          : formData.OrganizationName;
      newCustomerInfo.DepartmentName = formData.DepartmentName ? formData.DepartmentName : '';
      newCustomerInfo.Street = formData.Street;
      newCustomerInfo.Address2 = formData.Address2;
      newCustomerInfo.City = formData.City;
      newCustomerInfo.CountryCode = formData.CountryCode;
      newCustomerInfo.StateCode = formData.StateCode;
      newCustomerInfo.PostalCode = formData.PostalCode;
      newCustomerInfo.PrimaryEmail = formData.PrimaryEmail;
      newCustomerInfo.Phone = formData.Phone;

      const verifyAddressRequestParams = {
        distributorNumber: cart.distributorNumber,
        referenceId: cart._id,
        addressLine1: newCustomerInfo.Street,
        addressLine2: newCustomerInfo.Address2,
        city: newCustomerInfo.City,
        stateCode: newCustomerInfo.StateCode,
        countryCode: newCustomerInfo.CountryCode,
        postalCode: newCustomerInfo.PostalCode,
      };

      verifyAddress = await DataService.verifyAddress(this.urls.istApiUrl, verifyAddressRequestParams);

      if (verifyAddress.isSuccess) {
        if (verifyAddress.normalizedAddress) {
          const normalizedAddress = verifyAddress.normalizedAddress;
          newCustomerInfo.Street = normalizedAddress.addressLine1;
          newCustomerInfo.Address2 = normalizedAddress.addressLine2 || '';
          newCustomerInfo.City = normalizedAddress.city;
          newCustomerInfo.PostalCode = normalizedAddress.postalCode;
        }

        const newCustomerNumber = await DataService.createNewCustomer(this.urls.istApiUrl, newCustomerInfo);

        // Setting New customer info cookie for HUP ELA flow
        const NewCustomerInfoCookieData = {
          customer_number: newCustomerNumber._id,
          customer_name: newCustomerInfo.OrganizationName,
        };

        this.setCookie('ecomm_custInfo', JSON.stringify(NewCustomerInfoCookieData), '.esri.com', 2000);

        cart.metadata.customer = {
          customerName: newCustomerInfo.OrganizationName,
          customerNumber: newCustomerNumber._id,
          customerType: 'new',
          industryCode: newCustomerInfo.IndustryCode,
          departmentName: newCustomerInfo.DepartmentName,
          taxAreaId: verifyAddress.taxAreaId,
        };

        cart.metadata.shippingAddress = {
          firstName: newCustomerInfo.FirstName,
          lastName: newCustomerInfo.LastName,
          email: newCustomerInfo.PrimaryEmail,
          phoneNumber: newCustomerInfo.Phone,
          addressLine1: newCustomerInfo.Street,
          addressLine2: newCustomerInfo.Address2,
          city: newCustomerInfo.City,
          stateCode: newCustomerInfo.StateCode,
          postalCode: newCustomerInfo.PostalCode,
          countryCode: newCustomerInfo.CountryCode,
        };

        cart.metadata.shopperInfo = {
          username: cart.username || this.state.profile.username,
          firstName: this.state.profile.firstName,
          lastName: this.state.profile.lastName,
          phoneNumber: this.state.profile.phoneNumber || '',
          email: this.state.profile.emailaddress,
          locale: cart.locale,
        };

        await this.onCustomerNumberChangeUpdate(cart, localeInfo);
      } else {
        this.setState({onVerifyAddressError: true, isCreatingNewCustomer: false});
        this.showHideModal('#verifyAddressErrorModal', '#verifyAddressErrorMessage', 'open');
      }
    } catch (err) {
      if (!verifyAddress) {
        this.setState({onVerifyAddressError: true, onVerifyAddressSystemError: true, isCreatingNewCustomer: false});
        this.showHideModal('#verifyAddressErrorModal', '#verifyAddressErrorMessage', 'open');
      } else {
        this.setState({isCreatingNewCustomer: false});
        this.showHideModal('#createCustomerErrorModal', '#createCustomerErrorMessage', 'open');
      }
    }
  }

  async onSwitchCustomerNumber() {
    try {
      this.setState({switchingCustomerNumber: true});

      let {profile, countries, states} = await this.setupProfile();
      this.setState({
        profile: profile,
        newCustomerInfo: profile.firstName ? this.setNewCustomerInfo(profile) : {},
        countries: countries,
        states: states,
      });

      const selectedCustomerNumber = _.find(this.state.customerNumbers, {selected: true});
      const localeInfo = await DataService.locale(this.urls.istApiUrl, selectedCustomerNumber.Country);
      let cart = this.state.cart;

      // Setting customer info cookie for HUP ELA flow
      const customerInfoCookieData = {
        customer_number: selectedCustomerNumber.CustomerNumber,
        customer_name: selectedCustomerNumber.OrganizationName,
      };

      this.setCookie('ecomm_custInfo', JSON.stringify(customerInfoCookieData), '.esri.com', 2000);

      if (!cart) {
        cart = await this.createCart(localeInfo);
        this.setState({cart: cart});
      }

      cart.metadata.customer = {
        customerName: selectedCustomerNumber.OrganizationName,
        customerNumber: selectedCustomerNumber.CustomerNumber,
        customerType: isNaN(selectedCustomerNumber.CustomerNumber) ? 'new' : 'existing',
        industryCode: selectedCustomerNumber.IndustryKey,
        departmentName: selectedCustomerNumber.Department,
        taxAreaId: selectedCustomerNumber.TaxJurisdictionCode,
        customerAssignmentGroup: selectedCustomerNumber.CustomerAssignmentGroup,
      };

      cart.metadata.shippingAddress = {
        firstName: this.state.profile.firstName,
        lastName: this.state.profile.lastName,
        phoneNumber: this.state.profile.phoneNumber,
        email: selectedCustomerNumber.OrganizationEmailAddress || this.state.profile.emailaddress,
        addressLine1: selectedCustomerNumber.Address1 || 'PO Box ' + selectedCustomerNumber.PoBox,
        addressLine2: selectedCustomerNumber.Address2,
        city: selectedCustomerNumber.City,
        stateCode: selectedCustomerNumber.State,
        postalCode: selectedCustomerNumber.Zipcode || selectedCustomerNumber.PoBoxZipcode,
        countryCode: selectedCustomerNumber.Country,
      };

      cart.metadata.shopperInfo = {
        username: cart.username || this.state.profile.username,
        firstName: this.state.profile.firstName,
        lastName: this.state.profile.lastName,
        phoneNumber: this.state.profile.phoneNumber || '',
        email: this.state.profile.emailaddress,
        locale: cart.locale,
      };

      await this.onCustomerNumberChangeUpdate(cart, localeInfo);
    } catch (error) {
      this.setState({switchingCustomerNumber: false});
    }
  }

  async onCustomerNumberChangeUpdate(cart, localeInfo) {
    let directCheckout = false;
    if (
      this.state.redirectUri?.includes('checkout.esri.com')
      || this.state.redirectUri?.includes('checkoutstg.esri.com')
    ) {
      directCheckout = true;
    }
    try {
      if (localeInfo.zone !== cart.zone && directCheckout == false) {
        // Cart zone is not updated for for VOUCHERS, HUPLA, Reports
        cart.zone = localeInfo.zone;
        cart.distributorNumber = localeInfo.distributorNumber;
        cart.currency = localeInfo.supportedCurrencies[0].currencyCode;
        cart.metadata.currency = localeInfo.supportedCurrencies[0];
        cart.metadata.formattedLocale = localeInfo.supportedLocales[0].formattedLocale;
        cart.metadata.isOmni = localeInfo.isOmni;
        cart.metadata.storeDomain = localeInfo.storeDomain;
      }

      // Reset subscription Data.
      if (cart.lineItems) {
        _.forEach(cart.lineItems, (item) => {
          item.startDate = dayjs().format();
          item.endDate = dayjs(item.startDate).add(1, 'years').subtract(1, 'days').format();
          item.subscriptionId = '';

          if (
            item.metadata
            && item.metadata.subscriptions
            && item.metadata.subscriptions.selected
            && item.metadata.subscriptions.selected.length > 0
          ) {
            item.metadata.subscriptions.selected = [];
          }
        });
      }

      await DataService.updateCart(this.urls.istApiUrl, cart);

      let refererPath = window.location.origin + window.location.pathname; // removing query parameters from current page url
      if (refererPath && refererPath.includes('int-store')) {
        // when user switch between int stores
        const zoneCode = this.getCookie('selectedZone').toLowerCase();
        refererPath = `https://${zoneCode}.esri.com`;
        this.setCookie('selectedZone', localeInfo.zone);
      } else if (localeInfo?.storeDomain?.includes('int-store')) {
        // when user switch from us to int store
        this.setCookie('selectedZone', localeInfo.zone);
      } else {
        // when user switch stores with different domain, example esri.com to esri.ca and selectedZone cookie is removed from esri.com domain
        this.removeCookie('selectedZone');
      }

      if (decodeURIComponent(window.location.href).includes('action=addToCart') || directCheckout == true) {
        // bypassing geoBlocking logic for VOUCHERS, HUPLA, Reports
        this.processCustomerNumberSelection(this.geoBlockingResponse);
      } else {
        this.geoBlockingResponse = await DataService.localeRedirectionv2(this.urls.istApiUrl, refererPath, '');
        this.checkoutCountryCode = localeInfo?.checkoutCountry?.toLowerCase();
        const locales = this.geoBlockingResponse.locales || [];
        const showPopup = locales.length && locales.some((locale) => locale.isRedirect);
        if (showPopup) {
          this.setState({showGeoBlockingPopup: true, switchingCustomerNumber: false, isCreatingNewCustomer: false});
        } else {
          this.processCustomerNumberSelection(this.geoBlockingResponse.locales[0]);
        }
      }
    } catch (e) {
      console.error('Error while updating cart with customer number change:', e);
    }
  }

  async processCustomerNumberSelection(localeRedirectionResponse) {
    try {
      if (
        localeRedirectionResponse
        && localeRedirectionResponse.cookies
        && localeRedirectionResponse.cookies.length > 0
      ) {
        localeRedirectionResponse.cookies.forEach((cookie) => {
          document.cookie = `${cookie.name}=${cookie.value};secure;${cookie.expires};path=${cookie.path};domain=${cookie.domain};`;
        });
      }

      if (
        localeRedirectionResponse
        && localeRedirectionResponse.localStorage
        && localeRedirectionResponse.localStorage.length > 0
      ) {
        localeRedirectionResponse.localStorage.forEach((item) => {
          localStorage.setItem(item.id, item.value);
        });
      }

      if (localeRedirectionResponse && localeRedirectionResponse.isRedirect) {
        if (window.adobeDataLayer) {
          window.adobeDataLayer.push({
            event: 'eventWebAppMsg',
            data: {
              eventType: 'page redirect',
              redirectReferrer: localeRedirectionResponse.redirect_uri,
            },
          });
        }
        window.location.href = localeRedirectionResponse.redirect_uri;
      } else {
        this.sendToRedirectUri();
      }
    } catch (error) {
      this.setState({switchingCustomerNumber: false});
    }
  }

  async handleGeoBlockingCtaClick(locale, link, isContactLink) {
    this.setCookie('selectedZone', locale.zone);

    if (locale.updateZone) {
      const cart = this.state.cart;
      await DataService.updateCartZone(this.urls.istApiUrl, cart._id, locale.zone);
    }

    if (isContactLink) {
      window.location.href = link;
    } else {
      this.processCustomerNumberSelection(locale);
    }
  }

  async createCart(locale) {
    const cartMap = toCartModel(
      {
        locale: locale,
        username: this.state.esriAuthInfo.userName,
      },
      cartDataSource.LOCALE,
    );
    const cartResponse = await DataService.createCart(this.urls.istApiUrl, cartMap);
    this.setCookie('eCommCartId', cartResponse._id); // set eComm Cart Cookie

    return !_.isEmpty(cartResponse) ? cartResponse : null;
  }

  setRedirectUri() {
    localStorage.removeItem('cn_redirect_uri');
    localStorage.setItem('cn_redirect_uri', this.state.redirectUri || this.urls.cartUrl);
  }

  sendToRedirectUri(event) {
    if (event) event.preventDefault();
    if (window.adobeDataLayer) {
      window.adobeDataLayer.push({
        event: 'eventWebAppMsg',
        data: {
          eventType: 'page redirect',
          redirectReferrer: localStorage.getItem('cn_redirect_uri'),
        },
      });
    }
    const redirectUri = localStorage.getItem('cn_redirect_uri');

    if (DOMPurify.isValidAttribute('a', 'href', redirectUri)) {
      window.location.href = redirectUri;
    } else {
      throw new Error('Invalid Redirect URL');
    }
  }

  authenticateUser() {
    window.__ESRIGlobalNavLoaded
      ? afterGNavLoaded()
      : document.addEventListener('ESRIGlobalNavLoaded', afterGNavLoaded);
    function afterGNavLoaded() {
      window.redirectToSignIn();
    }
  }

  showHideModal(modalName, modalErrorMsg, type) {
    const errorModal = document.querySelector(modalName);
    const errorMessage = document.querySelector(modalErrorMsg);

    if (errorModal) {
      if (type === 'open') {
        errorModal.dataset.attribute = 'visible';
      } else {
        errorModal.dataset.attribute = 'hidden';
      }
    }

    if (errorMessage) {
      if (type === 'open') {
        errorMessage.dataset.attribute = 'visible';
      } else {
        errorMessage.dataset.attribute = 'hidden';
      }
    }
  }

  onSelectSwitchCustomerNumber() {
    if (this.state.switchingCustomerNumber) return;

    if (this.state.isPristineSelection) {
      this.setState({isPristineSelection: false});
    }

    const selectedCustomerNumber = _.find(this.state.customerNumbers, {selected: true});
    if (selectedCustomerNumber) {
      this.onSwitchCustomerNumber();
    } else {
      this.setState({showInvalidError: true});
    }
  }

  setNewCustomerInfo(profile, customerType) {
    if (!profile) return {};

    return {
      UserName: profile.username,
      FirstName: profile.firstName,
      LastName: profile.lastName,
      PrimaryEmail: profile.emailaddress,
      Phone: profile.phoneNumber,
      OrganizationName: customerType === 'individual' ? profile.firstName + ' ' + profile.lastName : '',
      DepartmentName: '',
      Street: customerType === 'individual' ? profile.addressLine1 : '',
      Address2: customerType === 'individual' ? profile.addressLine2 : '',
      City: customerType === 'individual' ? profile.city : '',
      CountryCode: customerType === 'individual' ? profile.countryCode : '',
      StateCode: customerType === 'individual' ? profile.stateCode : '',
      PostalCode: customerType === 'individual' ? profile.postalCode : '',
      IndustryCode: customerType === 'individual' ? 'Z' : 'V2',
    };
  }

  async initCreateCustomer(cart) {
    window.scrollTo({
      top: 0,
    });
    this.setState({
      cart: cart,
      isLoaded: false,
      initCustomerCreation: true,
    });

    let {profile, countries, states} = await this.setupProfile();

    const hasPersonalOrStudentUse = cart?.lineItems?.some((item) => isPersonalOrStudentUse(item)) || false;
    const selected = hasPersonalOrStudentUse ? 'individual' : 'business';
    this.customerTypes.forEach((customerType) => {
      customerType.selected = customerType.type === selected;
    });

    this.setState({
      profile: profile,
      formError: {},
      selectedCustomerType: selected,
      newCustomerInfo: this.setNewCustomerInfo(profile, selected),
      countries: countries,
      states: states,
      isLoaded: true,
    });
  }

  async setupProfile() {
    const profileResponse = await DataService.getUserProfile(this.urls.istApiUrl);
    let language
      = this.state.cartResponse && this.state.cartResponse.locale
        ? this.state.cartResponse.locale.split('-')[0]
        : profileResponse.PreferredLangCode;

    const profile = {
      firstName: profileResponse.FirstName,
      lastName: profileResponse.LastName,
      phoneNumber: profileResponse.Phone,
      emailaddress: profileResponse.PrimaryEmail,
      addressLine1: profileResponse.Street,
      addressLine2: profileResponse.Address2,
      city: profileResponse.City,
      stateCode: profileResponse.StateCode,
      countryCode: profileResponse.CountryCode,
      postalCode: profileResponse.PostalCode,
      username: profileResponse.UserName,
      language: language,
    };

    const [countriesLookup, statesLookup] = await axios.all([
      DataService.getCountries(this.urls.lookupAPIUrl, this.state.language || 'en'),
      DataService.getStates(this.urls.lookupAPIUrl, profile.countryCode ? profile.countryCode : 'US', language),
    ]);

    const countries = [],
      states = [];

    countriesLookup.map((item) => countries.push({display: item.localizedCountry[0].name, value: item.code}));
    statesLookup.map((item) => states.push({display: item.localizedName, value: item.code}));
    return {
      profile: profile,
      countries: countries,
      states: states,
    };
  }

  handleFormChange(event) {
    const {name, value} = event.target;
    const newCustomerInfo = this.state.newCustomerInfo;
    newCustomerInfo[name] = value;
    const formError = this.state.formError;
    delete formError[name];
    this.setState({newCustomerInfo: newCustomerInfo, formError: formError});
  }

  async onCountryChange(countryCode) {
    try {
      let language = 'en';

      if (this.state.cart && this.state.cart.locale) {
        language = this.state.cart.locale.split('-')[0];
      } else if (this.analytics.getPageItem('locale').includes('-')) {
        language = this.analytics.getPageItem('locale').split('-')[0];
      }

      const statesLookup = await DataService.getStates(this.urls.lookupAPIUrl, countryCode, language);
      const states = [];

      statesLookup.map((item) => states.push({display: item.localizedName, value: item.code}));

      const newCustomerInfo = this.state.newCustomerInfo;
      newCustomerInfo.CountryCode = countryCode;
      newCustomerInfo.StateCode = '';

      this.setState({
        states: states,
        newCustomerInfo: newCustomerInfo,
      });
    } catch {
      // nothing as of now. Maybe need to revisit.
    }
  }

  onStateChange(stateCode) {
    const newCustomerInfo = this.state.newCustomerInfo;
    newCustomerInfo.StateCode = stateCode;
    this.setState({newCustomerInfo: newCustomerInfo});
  }

  onSelectedCustomerNumber(customerNumber) {
    this.state.customerNumbers.map(
      (customerNumberItem) => (customerNumberItem.selected = customerNumberItem === customerNumber),
    );
    this.setState({isLoaded: true});
  }

  onSelectedCustomerType(customerType) {
    this.setState({
      selectedCustomerType: customerType.type,
      formError: {},
      newCustomerInfo: this.setNewCustomerInfo(this.state.profile, customerType.type),
      isCreatingNewCustomer: false,
    });
  }

  setEnvUrls() {
    this.urls['cartUrl'] = window.storeVariables.cartUrl;
    this.urls['customerNumberUrl'] = window.storeVariables.customerNumberUrl;
    this.urls['istApiUrl'] = window.storeVariables.eCommUrl;
    this.urls['lookupAPIUrl'] = window.storeVariables.lookupUrl;
    this.urls['accountsUrl'] = window.storeVariables.accountsUrl;
    this.urls['checkoutUrl'] = window.storeVariables.checkoutUrl;
  }

  goToCart(event) {
    event.preventDefault();
    window.location.href = this.urls.cartUrl;
  }

  replaceAllDynamicString(str, data) {
    try {
      return str.replace(/({([^}]+)})/g, function (match) {
        let key = match.replace(/{/g, '').replace(/}/g, '');
        if (data[key] === undefined) {
          return match;
        }
        return data[key];
      });
    } catch {
      // do nothing
      return str; // Return the original string if there is an error
    }
  }

  setCookie(cookieName, cookieValue, cookieDomain, expires) {
    const domain = cookieDomain || getRootDomain(location.host);
    Cookies.set(cookieName, cookieValue, {expires: expires || 2000, path: '/', domain: domain});
  }

  getCookie(cookieName) {
    return Cookies.get(cookieName);
  }

  getJSONCookie(cookieName) {
    try {
      return JSON.parse(Cookies.get(cookieName));
    } catch (e) {
      return null;
    }
  }

  removeCookie(cookieName) {
    const domain = getRootDomain(location.host);
    Cookies.remove(cookieName, {domain: domain, path: '/'});
  }
}

CustomerNumber.propTypes = {
  globalCustomerNumberLabel: PropTypes.string.isRequired,
  createCustomerNumberLabel: PropTypes.string.isRequired,
  switchCustomerNumberLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  purchasingForLabel: PropTypes.string.isRequired,
  continueToCheckoutLabel: PropTypes.string.isRequired,
  returnToCartLabel: PropTypes.string.isRequired,
  loadingCustomerNumberLabel: PropTypes.string.isRequired,
  selectCustomerNumberLabel: PropTypes.string.isRequired,
  selectCustomerNumberDescription: PropTypes.string.isRequired,
  selectCustomerNumberFootnote: PropTypes.string,
  continueLabel: PropTypes.string.isRequired,
  okayLabel: PropTypes.string.isRequired,
  firstNameLabel: PropTypes.string.isRequired,
  lastNameLabel: PropTypes.string.isRequired,
  orgNameLabel: PropTypes.string.isRequired,
  departmentLabel: PropTypes.string,
  addressLine1Label: PropTypes.string.isRequired,
  addressLine2Label: PropTypes.string,
  cityLabel: PropTypes.string.isRequired,
  stateLabel: PropTypes.string.isRequired,
  countryLabel: PropTypes.string.isRequired,
  postalCodeLabel: PropTypes.string.isRequired,
  emailLabel: PropTypes.string.isRequired,
  phoneNumberLabel: PropTypes.string.isRequired,
  firstNameRequiredMsg: PropTypes.string.isRequired,
  lastNameRequiredMsg: PropTypes.string.isRequired,
  orgNameRequiredMsg: PropTypes.string.isRequired,
  addressLine1RequiredMsg: PropTypes.string.isRequired,
  cityRequiredMsg: PropTypes.string.isRequired,
  stateRequiredMsg: PropTypes.string.isRequired,
  countryRequiredMsg: PropTypes.string.isRequired,
  postalCodeRequiredMsg: PropTypes.string.isRequired,
  emailRequiredMsg: PropTypes.string.isRequired,
  phoneNumberRequiredMsg: PropTypes.string.isRequired,
  customerNumberErrorMessageTitle: PropTypes.string.isRequired,
  customerNumberErrorMessage: PropTypes.string.isRequired,
  verifyAddressErrorTitle: PropTypes.string,
  verifyAddressErrorMessage: PropTypes.string.isRequired,
  verifyAddressSystemError: PropTypes.string.isRequired,
  personalCustomerTypeLabel: PropTypes.string.isRequired,
  orgCustomerTypeLabel: PropTypes.string.isRequired,
  newCustomerNumberLabel: PropTypes.string.isRequired,
  orgAccountDescription: PropTypes.string.isRequired,
  personalAccountDescription: PropTypes.string.isRequired,
  customerTypeSelectionDescription: PropTypes.string.isRequired,
  newLabel: PropTypes.string.isRequired,
  customerNumberTitle: PropTypes.string.isRequired,
  newCustomerNumberDescription: PropTypes.string.isRequired,
  backLabel: PropTypes.string.isRequired,
  alertTitleNoCustomerSelected: PropTypes.string.isRequired,
  alertMessageNoCustomerSelected: PropTypes.string.isRequired,
  validationErrorMessageNoCustomerSelected: PropTypes.string.isRequired,
  customerTypeMeLabel: PropTypes.string.isRequired,
  customerTypeOrgLabel: PropTypes.string.isRequired,
};

MapTo('esri-sites/components/content/customer-number')(CustomerNumber);

export default CustomerNumber;
